import Vue from 'vue'
import Router from 'vue-router'

// Firebase
import firebase from '../modules/firebase'
// Store
// import store from '../modules/store'
// Auth
// import auth from '../modules/auth'

// Components
import Main from '@/components/Main'
import Login from '@/components/Login'
import Signup from '@/components/Signup'
import Logout from '@/components/Logout'
// import Members from '@/components/Members'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {path: '/', name: 'Main', component: Main, meta: {auth: true}},
    {path: '/login', name: 'Login', component: Login},
    {path: '/iscrizione', name: 'Signup', component: Signup},
    {path: '/logout', name: 'Logout', component: Logout},
    // {path: '/members', name: 'Members', component: Members},
    // {path: '/', redirect: {name: 'Main', query: {status: 'active'}}},
    {path: '*', redirect: {name: 'Main'}}
    // redirect: {name: 'Weddings', query: {entry: 'upcoming'}},
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// Navigation guard
router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged((user, error) => {
    if (user) {
      firebase.database().ref('members/users/').child(user.uid).once('value', (snapshot) => {
        next()
        if (to.name === 'Login' || to.name === 'Signup') {
          next({name: 'Main'})
        } else {
          next()
        }
      })
    } else {
      if (to.matched.some(record => record.meta.auth)) {
        next({name: 'Login'})
      } else {
        next()
      }
    }
  })
})

// router.beforeEach((to, from, next) => {
//   firebase.auth().onAuthStateChanged((user, error) => {
//     if (to.matched.some(record => record.meta.auth)) {
//       if (!user) {
//         next({name: 'Login'})
//       } else {
//         next()
//       }
//     } else {
//       if (user) {
//         firebase.database().ref('users/').child(user.uid).once('value', (snapshot) => {
//           store.member = snapshot.val()
//           console.log(store.member)
//           console.log('bum')
//           if (to.name === 'Login' || to.name === 'Signup') {
//             // console.log(to.name)
//             next({name: 'Main'})
//           }
//         })
//       }
//       next()
//     }
//   })
// })
//
export default router



// WEBPACK FOOTER //
// ./src/router/index.js